import { ModelSagres } from "../model-sagres"
import { Suspensao } from "./suspensao";
interface ArquivoImpedimento {
    IdArquivo: number;
    NmArquivo: string;
    DtUltimaAlteracao: Date;
    IdSuspensao: number;
}

interface ArquivoSuspensao {
    IdArquivo: number;
    NmArquivo: string;
    DtUltimaAlteracao: Date;
    IdSuspensao: number;
}



interface TipoFundamentoImpedimento {
    IdFundamento: number;
    DeFundamento: string;
    DtAnomesativacao: Date
    DtAnomesdesativacao: Date
    DtUltimaAlteracao: Date;
    ImpedimentoContratacaos: any[];
}

export class Impedimentos extends ModelSagres {
    IdImpedimento: number
    TpPessoa: string
    NrCpfcnpj: string
    NmNome: string
    NrProtocolo: string
    NrAnoprotocolo: string
    DtProtocolo: Date
    DeBaselegal: string
    NrFundamento: string
    DtFundamento: Date
    DtInicioimpedimento: Date
    DtFimimpedimento: Date
    NomeDoArquivo: string
    DeEspecificafundamento: string


    NmArquivoSuspensao: string
    NomeUg?: string
    CodUgSagres: string
    IdFundamento: number
    DeFundamento: string
    deAnoNroProtocolo: string
    suspensao: Suspensao
    tipoFundamentoImpedimento?: TipoFundamentoImpedimento
    arquivoImpedimento?: ArquivoImpedimento
    arquivoSuspensao?: ArquivoSuspensao | null
    arquivo?: ArquivoImpedimento | File | null

    /**
     * Trata os dados recebidos pela API. Não execute em outras situações
     * @since 20220613
     */
    // tratarDadosDaAPI(): void {
    //     if (this.DtFundamento) {
    //         this.DtFundamento = new Date(this.DtFundamento)
    //     }
    //     if (this.DtInicioimpedimento) {
    //         this.DtInicioimpedimento = new Date(this.DtInicioimpedimento)
    //     }
    //     if (this.DtFimimpedimento) {
    //         this.DtFimimpedimento = new Date(this.DtFimimpedimento)
    //     }
    //     if (this.DtProtocolo) {
    //         this.DtProtocolo = new Date(this.DtProtocolo)
    //     }
    //     if (this.DtSuspensao) {
    //         this.DtSuspensao = new Date(this.DtSuspensao)
    //     }
    //     this.deAnoNroProtocolo = this.NrAnoprotocolo + '/' + this.NrProtocolo
    //     this.IdFundamento = this.tipoFundamentoImpedimento!.IdFundamento
    //     this.DeFundamento = this.tipoFundamentoImpedimento!.DeFundamento
    // }

    constructor(obj?: any) {
        super();
        if (obj) {
            if (obj.IdImpedimento) this.IdImpedimento = obj.IdImpedimento
            if (obj.TpPessoa) this.TpPessoa = obj.TpPessoa
            if (obj.NrCpfcnpj) this.NrCpfcnpj = obj.NrCpfcnpj
            if (obj.NmNome) this.NmNome = obj.NmNome
            if (obj.NrProtocolo) this.NrProtocolo = obj.NrProtocolo
            if (obj.NrAnoprotocolo) this.NrAnoprotocolo = obj.NrAnoprotocolo
            if (obj.DtProtocolo) this.DtProtocolo = new Date(obj.DtProtocolo)
            if (obj.DeBaselegal) this.DeBaselegal = obj.DeBaselegal
            if (obj.NrFundamento) this.NrFundamento = obj.NrFundamento
            if (obj.DtFundamento) this.DtFundamento = new Date(obj.DtFundamento)
            if (obj.DtInicioimpedimento) this.DtInicioimpedimento = new Date(obj.DtInicioimpedimento)
            if (obj.DtFimimpedimento) this.DtFimimpedimento = new Date(obj.DtFimimpedimento)
            if (obj.NomeDoArquivo) this.NomeDoArquivo = obj.NomeDoArquivo
            if (obj.DeEspecificafundamento) this.DeEspecificafundamento = obj.DeEspecificafundamento

            if (obj.NmArquivoSuspensao) this.NmArquivoSuspensao = obj.NmArquivoSuspensao

            if (obj.NomeUg) this.NomeUg = obj.NomeUg
            if (obj.CodUgSagres) this.CodUgSagres = obj.CodUgSagres
            if (obj.IdFundamento) this.IdFundamento = obj.IdFundamento
            if (obj.DeFundamento) this.DeFundamento = obj.DeFundamento
            this.suspensao = obj.Suspensao ? new Suspensao(obj.Suspensao) : new Suspensao(obj.suspensao)
            this.deAnoNroProtocolo = `${this.NrAnoprotocolo ?? '-'}` + '/' + `${this.NrProtocolo ?? '-'}`
            if (obj.tipoFundamentoImpedimento) this.tipoFundamentoImpedimento = obj.tipoFundamentoImpedimento
            if (obj.arquivoImpedimento) this.arquivoImpedimento = obj.arquivoImpedimento
            if (obj.arquivoSuspensao) this.arquivoSuspensao = obj.arquivoSuspensao


        } else {
            this.suspensao = new Suspensao()
        }
    }
}